import { ViewNode } from './ViewNode';
import { Mesh } from 'three';
import { changeUserData, setUserData } from '../../types';
export class Model3dNode extends ViewNode {
    constructor(key) {
        super(key);
        this.key = key;
    }
    init(params) {
        this.params = params;
        if (params.settings) {
            this.setSettings(params.settings);
        }
    }
    getPrefetchAssets() {
        const url = this.params.url;
        return [
            {
                type: 'Model3d',
                key: url,
                url,
            },
        ];
    }
    build() { }
    mount(params) {
        var _a;
        const { container, assetsApi, materialsApi } = params;
        const model3d = (_a = assetsApi.getModelAsset(this.params.url)) === null || _a === void 0 ? void 0 : _a.clone();
        setUserData(container, this.getSettings());
        if (model3d) {
            this.updateModelMaterials(model3d, materialsApi);
            this.hideRequestedMeshes(model3d);
            container.add(model3d);
        }
    }
    updateModelMaterials(model3d, materialsApi) {
        var _a;
        const params = this.params;
        for (const material of (_a = params.meshesMaterials) !== null && _a !== void 0 ? _a : []) {
            const modelMesh = model3d.getObjectByName(material.meshName);
            if (!(modelMesh instanceof Mesh)) {
                console.warn(`Cannot find mesh "${material.meshName}" in model "${this.key}. Skipped material ${material.materialKey}"`);
                continue;
            }
            const modelMaterial = materialsApi.get(material.materialKey);
            if (!modelMaterial) {
                console.warn(`Cannot find material "${material.materialKey}"`);
                continue;
            }
            modelMesh.material = modelMaterial;
        }
    }
    hideRequestedMeshes(model3d) {
        var _a;
        const params = this.params;
        for (const { mesh, visible, webAr } of (_a = params.hiddenMeshes) !== null && _a !== void 0 ? _a : []) {
            let found = false;
            model3d.traverse((node) => {
                if (node.name === mesh) {
                    found = true;
                    node.visible = visible;
                    changeUserData(node, { webAr });
                }
            });
            if (!found) {
                console.warn(`Cannot find mesh or group "${mesh}" in model "${this.key}"`);
            }
        }
    }
}
//# sourceMappingURL=Model3dNode.js.map